import { render, staticRenderFns } from "./CustomerSegmentReceivingForm.vue?vue&type=template&id=db75bcfc&scoped=true&"
import script from "./CustomerSegmentReceivingForm.vue?vue&type=script&lang=js&"
export * from "./CustomerSegmentReceivingForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSegmentReceivingForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerSegmentReceivingForm.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CustomerSegmentReceivingForm.vue?vue&type=style&index=2&id=db75bcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db75bcfc",
  null
  
)

export default component.exports